import { Routes } from '@angular/router';
import { ContactComponent } from './contact.component';
import { ContactType01Component } from './contact-type01/contact-type01.component';

export default [
    {
        path     : '', component:ContactComponent
    },
    
] as Routes;
